import React, { useEffect } from "react";
import { isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, postHeader } from "../../../../../Helpers/request";
import { useState } from "react";
import { toast } from "react-toastify";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BannerSlider = () => {
  const [screen, setScreen] = useState(window.innerWidth);
  const onScreenLoad = () => {
    setScreen(window.innerWidth)
  }

  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2800,
    cssEase: "ease-in-out",
  };

  useEffect(() => {


    getSlider()

    onScreenLoad()

    window.addEventListener("resize", onScreenLoad)
    return () => {
      window.removeEventListener("resize", onScreenLoad)
    }
  }, []);

  const getSlider = async () => {
    setLoading(true);
    await axios
      .get(base_url + `/home/slider`, {
        headers: postHeader,
      })
      .then((response) => {
        if (response?.data?.status == 1) {
          setLoading(false);
          setBanner(response?.data?.data);

        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <>
    
      <div className="w-100">
        <Slider {...settings}>
          <div>
            {!loading ? (
              banner?.map((val, index) => (
                <div className="position-relative" key={index}>

                  <img src={screen < 767 ? val?.mobile_image : val?.image} alt={val?.alt_tag} className="w-100" fetchpriority="high" />
                  <div className="rcs_hero_slider ">
                    {val.btn_text === "" ? (
                      ""
                    ) : (
                      <div
                        className={`${isMobileOnly ? "text-center" : val?.text_direction_class
                          } text-left`}
                      >
                        <h1 data-aos="fade-up-left" data-aos-duration="700" className="text-left">
                          {val.title}
                        </h1>
                        <p
                          data-aos="fade-up-left"
                          data-aos-duration="1200"
                          data-aos-delay="300"
                        >
                          {val?.short_text}
                        </p>
                  
                        <Link
                          data-aos="fade-up-left"
                          data-aos-duration="1800"
                          data-aos-delay="400"
                          to={"/" + val.btn_link}
                          className="outline-base-btn large"
                        >
                          {val?.btn_text}
                        </Link>
                      </div>
                    )}
                    {/* </Col>
                </Row> */}
                    {/* </Container> */}
                    {/* </div> */}
                  </div>
                </div>

              ))
            ) : (
              <div className="sk" style={{ margin: "0px" }}>
                <Skeleton variant="text" animation="wave" height={"90vh"} />
              </div>
            )}
          </div>
          {/* <div>
            <img src={screen < 767 ? require("../assets/images/eid_adha_mob.webp") : require("../assets/images/eid_adha.webp")} alt="Eid ul adha" className="w-100" />
          </div> */}

        </Slider>
      </div>

    </>
  );
};

export default BannerSlider;
